export default "__VITE_ASSET__BPCGS_xH__"